/**
 * Terminal 82 - Theme Utilities
 *
 * Theme colors are defined in CSS (src/styles/base.css).
 * This module only provides class name utilities.
 */

import type { ThemeId } from '../types';

/**
 * Get CSS class name for a theme
 */
export function getThemeClass(themeId: ThemeId): string {
  return `theme-${themeId}`;
}

/**
 * Get CSS class names for a theme (array for backwards compatibility)
 */
export function getThemeClasses(themeId: ThemeId): string[] {
  return [getThemeClass(themeId)];
}
